module.exports = __webpack_public_path__ + "media/images/emblems/Menzingen-coat_of_arms-89e82e57cd8be5ec86cc303b4858ff12.svg";